export enum SortOption {
  ASC = 'asc',
  DESC = 'desc',
}
export interface CatalogFilter {
  category__in: string
  category: string
  category__parent: string
  shop: string
  shop__in: string
  min_price: string
  max_price: string
  ordering: 'price_after_discount' | '-price_after_discount'
  discounted: boolean
  product_base: number
  tags: string | string[]
  search: string
  event_id: string
  event_slug: string
}

export interface FilterTag {
  id: number
  name: string
  icon: string
  is_selected: boolean
  product_pk: string | number
}
export enum CatalogType {
  SHOP = 'shop',
  CATEGORY = 'category',
}
